import { FieldComponentLoader, MPS_COMPONENT_REGISTRY } from '../interfaces/mps-component-config.interface';

export function mpsRegisterComponents(components: Record<string, FieldComponentLoader>) {
  Object.assign(MPS_COMPONENT_REGISTRY, components);
}
